import { ICheckboxesTreeItem } from "../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree/stores/checkboxes-tree-store";
import {IChangeable} from "../../../stores/types";
import {IReturnLabelSettingCarrier, IReturnLabelSettingService} from "../return-method-types";
import {makeAutoObservable} from "mobx";

interface IReturnLabelSettingServiceChanges extends Partial<IReturnLabelSettingService> {
    service_code: string
    service_name: string
}
interface IReturnLabelSettingCarriersChange extends Partial<Omit<IReturnLabelSettingCarrier, 'return_label_setting_services'>> {
    return_label_setting_services?: IReturnLabelSettingServiceChanges[];
}

export default class ReturnLabelSettingCarrierStore implements IChangeable<IReturnLabelSettingCarrier> {

    private _model?: IReturnLabelSettingCarrier;
    private _changes: IReturnLabelSettingCarriersChange = {};

    constructor(model?: IReturnLabelSettingCarrier) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._model = model;
    }

    public getCarrierCode() {
        return this._changes.carrier_code ?? this._model?.carrier_code;
    }

    public getCarrierName() {
        return this._changes.carrier_name ?? this._model?.carrier_name;
    }
    
    public setCarrierOption(option: ICheckboxesTreeItem): void {
        /** TODO: do not set changes, or delete them if received option is same as the model to detect changes, at the moment we always set changes */
        this._changes.carrier_code = option.value;
        this._changes.carrier_name = option.label;

        /** When there is a change in carrier selection - then services can be ubdefined, which means that everything is selected. */
        this._changes.return_label_setting_services = option.childNodes?.map(serviceOp => {
            return {
                service_code: serviceOp.value,
                service_name: serviceOp.label, 
            };
        }) ?? [];
    }

    public getCarrierOption(): ICheckboxesTreeItem {
        return {
            value: this.getCarrierCode() as string,
            label: this.getCarrierName() as string,
            childNodes: this._services.map(service => ({
                value: service.service_code,
                label: service.service_name,
            }))
        };
    }    
    
    private get _services(): IReturnLabelSettingServiceChanges[] {
        return this._changes?.return_label_setting_services ?? this._model?.return_label_setting_services ?? [];
    }

    discardChanges(): void {
        this._changes = {};
    }

    getUpdatedModel(): IReturnLabelSettingCarrier {
        return  {
            ...this._model, 
            ...this._changes,
            _has_changes: this.hasChanges(), 
            _deleted: this.deleted() 
        } as IReturnLabelSettingCarrier;
    }

    /** created and deleted on client */
    isGhost(): boolean {
        return this.deleted() && !this._model;
    }

    hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public setDeleted(v: boolean) {
        this._changes._deleted = v;
    }

    public deleted(): boolean {
        return this._changes._deleted ?? false;
    }
}